import React, { ChangeEvent, Component } from 'react';
import FormicaLabel from '../../../custom/FormicaLabel';
import { ClickTriggerJsonModel, CustomTriggerJsonModel } from '../../../../domain/tracker/trigger/TriggerJsonModel';
import RoleHelper from '../../../../RoleHelper';
import FormicaInput from '../../../custom/FormicaInput';
import FormicaToggleSwitch from '../../../custom/FormicaToggleSwitch';

class ClickTriggerComponent extends Component<Props> {
  public render() {
    const { trigger } = this.props;
    return (
      <div className={'border-b py-5'}>
        <div className={'flex flex-col gap-y-1'}>
          <FormicaLabel label={'Just Links'} />
          <FormicaToggleSwitch value={trigger.justLinks} onChange={this.onToggle} disabled={!RoleHelper.canEdit('Tracker')} />
        </div>
      </div>
    );
  }

  private onToggle = (e: any) => {
    const { trigger, onChange } = this.props;
    trigger.justLinks = !trigger.justLinks;
    onChange(trigger);
  };
}

interface Props {
  trigger: ClickTriggerJsonModel;
  onChange: (trigger: ClickTriggerJsonModel) => void;
}

export default ClickTriggerComponent;
